module.exports = __webpack_public_path__ + "static/media/icon-pause.818456f8.svg";